module.exports = __webpack_public_path__ + "img/knowledge.649e6bb5.png";